import { render, staticRenderFns } from "./bookingChannelConfig.vue?vue&type=template&id=b5f8389e&"
import script from "./bookingChannelConfig.vue?vue&type=script&lang=js&"
export * from "./bookingChannelConfig.vue?vue&type=script&lang=js&"
import style0 from "./bookingChannelConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5f8389e')) {
      api.createRecord('b5f8389e', component.options)
    } else {
      api.reload('b5f8389e', component.options)
    }
    module.hot.accept("./bookingChannelConfig.vue?vue&type=template&id=b5f8389e&", function () {
      api.rerender('b5f8389e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/bookingChannelConfig.vue"
export default component.exports